//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";

export default {
  data: function () {
    return {
      title: "Current Drill Position",
    };
  },
  computed: {
    ...mapState({
      currentDrillPosition: state => state.drilling.currentDrillPosition,
    }),
  },
};
